<template>
    <div class="pt461" id="pt461">
        <breadcrumb :navListCustom="[{title:'マイページ', routerName: pt461DoInit.myPage, param: {pageNo: '81'}}, {title:$t('pt120.labels.itemReviewTitle'), routerName: pt461DoInit.reviewListPage, param: {pageNo: '84', processKbn:'0'}}, {title:$t('pt461.labels.title'), routerName: '', param: {}}]"></breadcrumb>
        <div>
            <!-- マイページ -->
            <div class="itemTitle">
                <h2>{{$t('common.labels.titleHeaderOrder')}}</h2>
            </div>
            <div class="">
                <!-- 商品レビュー -->
                <h3>{{$t('pt461.labels.title')}}</h3>
                <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="'pt461error'"/>
                <!-- 冒頭メッセージ -->
                <div class="topDescription" v-html="descriptionInfo[1]"></div>
                <table class="reviewTable1">
                    <tr class="itemImage">
                        <th>
                            <!--商品画像-->
                            <img class="productImage" :src="pt461RespModel.imageUrl" alt="pt461RespModel.thumbnailDetail" @error="getErrImage"></th>
                        <td>
                            <span> {{pt461RespModel.itemNm}}</span>
                        </td>
                    </tr>
                    <tr class="reviewRankKbn">
                        <!-- 評価 -->
                        <th class="required" id="reviewRankKbn_lbl">{{$t('pt461.labels.reviewRankKbn')}}</th>
                        <td>
                            <div class="reviewStar" v-for="n in [0,1,2,3,4]" :key="n">
                                <div class="reviewStarLeft" @mouseenter="starEnter(n+0.5)" @mouseleave="starOut()" @click="starRank(n+0.5)" :class="starLeft(n+0.5)"></div>
                                <div class="reviewStarRight" @mouseenter="starEnter(n+1)" @mouseleave="starOut()" @click="starRank(n+1)" :class="starRight(n+1)"></div>
                            </div>
                        </td>
                    </tr>
                    <tr class="reviewTitle">
                    <!-- レビュータイトル -->
                        <th class="required" id="title_lbl">{{$t('pt461.labels.reviewTitle')}}</th>
                        <td>
                            <input-check v-model="pt461RespModel.title" maxlength="100" style="width: 100%;" name="title" type="text" />
                        </td>
                    </tr>
                    <tr class="review">
                        <!-- レビュー内容 -->
                        <th class="required" id="review_lbl">{{$t('pt461.labels.review')}}</th>
                        <td>
                            <input-check v-model="pt461RespModel.review"  rows="10" cols="50" :classify="'textarea'" class="multi" name="contents" type="text" />
                        </td>
                    </tr>
                    <tr class="reviewImage1">
                        <!-- レビュー画像1 -->
                        <th class="optional">{{$t('pt461.labels.reviewImage1')}}</th>
                        <td>
                            <Uploader v-model="pt461RespModel.image1" @change="onFileChange('image1',$event)"></Uploader>
                        </td>
                    </tr>
                    <tr class="reviewImage2">
                        <!-- レビュー画像2 -->
                        <th class="optional">{{$t('pt461.labels.reviewImage2')}}</th>
                        <td>
                            <Uploader v-model="pt461RespModel.image2" @change="onFileChange('image2',$event)"></Uploader>
                        </td>
                    </tr>
                    <tr class="reviewImage3">
                        <!-- レビュー画像3 -->
                        <th class="optional">{{$t('pt461.labels.reviewImage3')}}</th>
                        <td>
                            <Uploader v-model="pt461RespModel.image3" @change="onFileChange('image3',$event)"></Uploader>
                        </td>
                    </tr>
                </table>
                <!-- 商品に関するお問い合わせはこちら -->
                <div class="reviewDescribe" v-html="descriptionInfo[2]"></div>
                <table class="reviewTable2">
                    <tr class="nickname">
                        <!-- ニックネーム -->
                        <th>{{$t('pt461.labels.nickname')}}</th>
                        <td>
                            <span>{{ pt461RespModel.niciname }}</span>
                        </td>
                    </tr>
                    <tr class="ageOpne">
                        <!-- 年齢 -->
                        <th>{{$t('pt461.labels.ageOpne')}}</th>
                        <td>
                            <span v-if="pt461RespModel.ageOpenFlg == 1">{{$t('pt461.labels.ageOpneMsg')}}</span>
                            <span v-else>{{$t('pt461.labels.agenotOpneMsg')}}</span>
                        </td>
                    </tr>
                    <tr class="sexOpne">
                        <!-- 性別 -->
                        <th>{{$t('pt461.labels.sexOpne')}}</th>
                        <td>
                            <span v-if="pt461RespModel.sexOpenFlg == 1">{{$t('pt461.labels.ageOpneMsg')}}</span>
                            <span v-else>{{$t('pt461.labels.agenotOpneMsg')}}</span>
                        </td>
                    </tr>
                </table>
                <ul class="buttonColumn">
                    <li>
                        <input type="submit" :value="$t('common.buttons.return')" :alt="$t('common.buttons.return')" @click="backPage" class="submitButton">
                    </li>
                    <li>
                        <input type="submit" :value="$t('pt461.buttons.submit')" :alt="$t('pt461.buttons.submit')" @click="confirmSendReview" class="submitButton">
                    </li>
                </ul>
            </div>
            <alert-confirm 
                v-if="isModalShow"
                :msgConfirm="msgConfirm"
                :isButtonCancel="isButtonCancel"
                :okAction="submit"
                :cancelAction="doCancelAction">
            </alert-confirm>
        </div>
    </div>
</template>
<script>

/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import axios from "assets/js/request";
import EventBus from 'assets/js/eventBus';
import AlertConfirm from 'components/AlertConfirm';
import Message from 'components/MessageEcSite';
import SiteConstants from 'assets/const/SiteConstants.json';
import InputNumber from "components/InputNumber";
import InputCheck from 'components/InputCheck.vue';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import Loading from 'vue-loading-overlay';
import Uploader from "../commonParts/Uploader.vue";
export default {
    /* 
    * Name of component
    */
    name: "PT461ItemReviewParts",
    /*
    * Declare props
    */
    props: {
        ptInitData: {
            type: Object,
            default: null,
        }
    },

    /* 
    * Get data from parent component
    */
    components:
    {
		EventBus,
        AlertConfirm,
		Message,
		InputNumber,
        InputCheck,
        Loading,
        Breadcrumb,
        Uploader
    },
    data() {
        return {
            pt461DoInit:{},
            listIdErr:[],
            pt461ReqModel:{},
			pt461RespModel:{},
			SiteConstants: SiteConstants,
            listMessValid:[],
            mapMessValid:[],
            descriptionInfo:[],
			isModalShow:false,
            msgConfirm:null,
            isButtonCancel:false,
			isButtonOK:false,
            starIndex :0,
            reviewRankKbn :0
        }
    },
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if (_this.ptInitData){
            _this.pt461DoInit = _this.ptInitData;
            _this.pt461RespModel = _this.ptInitData.reqModel;
        }
        axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT461 + _this.$UrlConstants.DO_CHECK,_this.pt461RespModel)
        .then(function(response) {
            _this.descriptionInfo = response.data.descriptionInfo;
        }).catch(function(error) {
            _this.$emit("event-loading", false);
            if(error != null && error != undefined){
                _this.isModalShow = false;
                if(error.response != null && error.response != undefined){
                    if(406 == error.response.status){
                        var resultValid = common.excuteValidationEcSite(error, _this.PT461_PART);
                        if(resultValid){
                            _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                            _this.listMessValid = resultValid.msgList;
                            _this.mapMessValid = resultValid.mapMsg;
                        }
                    }else{
                        common.errorAPI(error);
                    }
                }
            }
        });
    },
    methods: {
        submit: function(){
            var _this = this;
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr);
            _this.$emit("event-loading", true);

            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT461 + _this.$UrlConstants.DO_UPDATE,_this.pt461RespModel)
            .then(function(response) {
                if(response.data.status == "OK"){
                    // レビュー一覧へ
                    const parameter = _this.generateLinkParams(84,_this.pt461DoInit.reviewListPage, {processKbn: 0});
                    _this.$router.push(parameter);
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                    if(error != null && error != undefined){
                        _this.isModalShow = false;
                        if(error.response != null && error.response != undefined){
                            if(406 == error.response.status){
                                var resultValid = common.excuteValidationEcSite(error, _this.PT461_PART);
                                if(resultValid){
                                    _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                    _this.listMessValid = resultValid.msgList;
                                    _this.mapMessValid = resultValid.mapMsg;
                                }
                            }else{
                                common.errorAPI(error);
                            }
                        }
                    }
                common.scrollTop();
            });
        },

        backPage: function(){
            var _this = this;
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT461_PART);
            // レビュー一覧へ
            const parameter = _this.generateLinkParams(84,_this.pt461DoInit.reviewListPage, {processKbn: 0});
            _this.$router.push(parameter);
        },
        // ルーターリンクパラメータ設定
        generateLinkParams(pageNo, customUrl, additionalQuery = {}, additionalParams = {}) {
            return common.routerLinkParams(pageNo, customUrl, additionalQuery, additionalParams);
        },
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
        confirmSendReview: function(){
			var _this = this;
			_this.isModalShow = true;
			// 入力した内容でレビューを送信します。よろしいですか？
			_this.msgConfirm =_this.$i18n.t('pt461.labels.confirmSendReview');
			_this.isButtonCancel=true;
			_this.isButtonOK=true;
		},
        starEnter: function(index){
            this.starIndex = index;
        },
        starOut: function(){
            this.starIndex = 0;
        },
        starRank: function(index){
            this.pt461RespModel.reviewRankKbn = index;
        },
        starLeft: function(index){
            let className = "";
            if(this.starIndex >= index || this.pt461RespModel.reviewRankKbn >= index){
                className = "reviewStarFullLeft";
            }
            return className;
        },
        starRight: function(index){
            let className = "";
            if(this.starIndex >= index || this.pt461RespModel.reviewRankKbn >= index){
                className = "reviewStarFullRight";
            }
            return className;
        },
        onFileChange(target,{ file,url }){
            this.pt461RespModel[target+"Data"] = file
            this[target] = url
        },
        doCancelAction: function(){
            this.isModalShow=false;
        }

    },
    /*
    * destroy eventbus of page before close page
    */
    beforeDestroy: function() {
        //close select-link eventbus
        EventBus.$off("select-link");
    },
    /*
    * Excute code after an instance is created
    */
    created: function(){
         var _this = this;
        // Get data from params and query
        var paramData = _this.$route.params;
        var queryData = _this.$route.query;
        if(Object.keys(paramData).length > 0){
            _this.pt461ReqModel.orderCd = paramData.orderCd;
            _this.pt461ReqModel.itemCd = paramData.itemCd;
            _this.pt461ReqModel.seq = paramData.seq;
        }else if(Object.keys(queryData).length > 0){
            _this.pt461ReqModel.itemCd = queryData.itemCd;
        } else {
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query:{pageNo:1}});
        }
    },
}
</script>